import { ServiceData } from '@/types';

import articles from './YOGA_ARTICLES_SK.json';
import exercises from './YOGA_EXERCISES_SK.json';
import recipes from './YOGA_RECIPES_SK.json';

export const YOGA_DATA_SK: ServiceData = {
  articles,
  exercises,
  recipes,
};
